var _path, _g, _circle, _g2, _circle2, _g3, _circle3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m441.4 140.2v338.8c0 18.2-14.8 33-33 33h-304.8c-18.2 0-33-14.8-33-33v-446c0-18.2 14.8-33 33-33h197.6z",
    fill: "#744abd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m187 257.7h163.8v21.1h-163.8z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 149.8,
    cy: 268.2,
    fill: "#fff",
    r: 11.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m187 317.7h163.8v21.1h-163.8z",
    fill: "#fff"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.8,
    cy: 328.2,
    fill: "#fff",
    r: 11.8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m187 377.7h163.8v21.1h-163.8z",
    fill: "#fff"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.8,
    cy: 388.2,
    fill: "#fff",
    r: 11.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m320.3 135.4 121.1 98.1v-92.1l-68.7-39.9z",
    opacity: 0.19
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m441.4 140.2h-107.2c-18.2 0-33-14.8-33-33v-107.2z",
    fill: "#b7a2dd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGForms);
export default __webpack_public_path__ + "static/media/g-forms.4cd89d96d2d3a104040d49e70b924ba1.svg";
export { ForwardRef as ReactComponent };